<template>
  <div
    v-if="isShowingNotifcation"
    class="global-notification-bar"
    :style="{ zIndex: -zIndex }"
  >
    <slot />
    <aha-icon
      v-if="showCloseButton"
      @click="handleClose"
      class="global-notification-close-button"
      name="close"
      width="18"
      height="18"
      viewBox="0 0 24 24"
    />
  </div>
</template>

<script>
export default {
  props: {
    zIndex: {
      type: Number,
      default: 0,
    },
    showCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowingNotifcation: true,
    }
  },
  methods: {
    handleClose() {
      this.isShowingNotifcation = false
    },
  },
}
</script>

<style lang="scss" scoped>
.global-notification-bar {
  @apply flex flex-col px-3 py-2 sm:px-10 sm:flex-row items-start sm:items-center;
  @apply min-h-11 bg-primary-100 text-base-0;
  @apply relative; // need position for box-shadow to show up using z-index
  box-shadow: 0px 4px 4px rgba(0, 61, 132, 0.18);
}

.global-notification-close-button {
  position: absolute;
  cursor: pointer;
  top: 50%;
  right: 2%;
  transform: translate(0, -50%);
  &:hover {
    color: #EBEBEB;
  }
}
</style>
